import { CHAPTERS, COMPANY } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const Manifesto = () => {
  return (
    <section
      id="about"
      data-testid="manifesto-section"
      className="relative bg-[#F5F1EA] py-24 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal className="max-w-3xl mb-20 md:mb-28">
          <span className="font-mono-tech text-[11px] uppercase tracking-[0.3em] text-[#0055FF]">
            / Our discipline
          </span>
          <h2 className="font-display font-800 tracking-tighter text-3xl md:text-5xl lg:text-6xl mt-6 leading-[0.95]">
            We started with food packaging.
            <span className="text-[#55524B]"> We didn&apos;t stop there.</span>
          </h2>
        </Reveal>

        <div className="border-t border-[#C9C3B4]">
          {CHAPTERS.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.05}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-b border-[#C9C3B4] group"
            >
              <div className="md:col-span-2">
                <span className="font-mono-tech text-sm text-[#0055FF] tracking-widest">
                  {c.n} /
                </span>
              </div>
              <div className="md:col-span-6">
                <h3 className="font-display font-500 text-2xl md:text-3xl tracking-tight leading-tight group-hover:text-[#0055FF] transition-colors duration-500">
                  {c.title}
                </h3>
              </div>
              <div className="md:col-span-4">
                <p className="text-[#55524B] leading-relaxed text-base">
                  {c.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
